<template>
  <div class="unaudited-customer">
    <crm-panel :title="'机构驳回客户'">
      <span class="mt20"></span>
      <div class="mt20">
        <el-form ref="form" :inline="true">
          <el-form-item label="">
            <el-input
              class="search-input"
              placeholder="根据客户名称查询"
              v-model="name"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="refusedCustomData && refusedCustomData.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          label="客户名称"
          prop="customerName"
          align="center"
        >
        </el-table-column>
        <el-table-column label="客户机构编号" prop="orgCode" align="center">
        </el-table-column>
        <el-table-column label="客户机构状态" prop="state" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.state === 3 ? '不通过' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{ row }">
            <el-button
              v-if="webCustomerAuth.organization.orgupdate.auth"
              @click="handleBind(row)"
              type="text"
              size="small"
            >
              绑定编码
            </el-button>
            <el-button
              v-if="webCustomerAuth.organization.orgapply.auth"
              @click="handleReply(row)"
              type="text"
              size="small"
            >
              重新申请
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageObj.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="pageObj.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="refusedCustomData && refusedCustomData.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <bind-code
      v-show="bindCode.visible"
      @close="bindCode.visible = false"
      @success="handleSearch"
      :visible="bindCode.visible"
      :uid="bindCode.uid"
    >
    </bind-code>

    <reply-again
      v-show="replyAgain.visible"
      @close="replyAgain.visible = false"
      @success="handleSearch"
      :visible="replyAgain.visible"
      :uid="replyAgain.uid"
    >
    </reply-again>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { formatTimeShow } from '@/scripts/utils';
import CrmPanel from '@/components/base/crmPanel';
import BindCode from '@/components/business/custom/bind-code.vue';
import ReplyAgain from '@/components/business/custom/reply-again.vue';

export default {
  components: {
    CrmPanel,
    BindCode,
    ReplyAgain,
  },
  data() {
    return {
      loading: true,
      name: null,
      pageObj: {
        pageNumber: 1,
        pageSize: 10,
      },
      bindCode: {
        visible: false,
        uid: null,
      },
      replyAgain: {
        visible: false,
        uid: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      refusedCustomData: 'customer/refusedCustomData',
      webCustomerAuth: 'authority/webCustomerAuth',
    }),
  },
  created() {
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getRefusedCustomer: 'customer/getRefusedCustomer',
    }),
    handleSearch() {
      this.pageObj.pageNumber = 1;
      this.handleGetData();
    },
    handleGetData() {
      this.getRefusedCustomer({
        name: this.name,
        ...this.pageObj,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleBind(row) {
      this.bindCode = {
        visible: true,
        uid: row.uid,
      };
    },
    handleReply(row) {
      this.replyAgain = {
        visible: true,
        uid: row.uid,
      };
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.pageObj.pageNumber = 1;

      this.handleGetData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pageObj.pageNumber = val;
      this.handleGetData();
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';

.unaudited-customer {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
